/**
 * @file SetTmpPassword
 */

'use strict';

/**
 * @classname SetTmpPassword
 * @classdesc SetTmpPassword
 */
export default class SetTmpPassword {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-set-tmp-password')
	 * @param {instance} controller - controller インスタンス
	 */
	constructor($e, controller) {
		console.log(`SetTmpPassword.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._$e.on('click', () => this.onClick());
		this._$successModal = document.getElementById('modal-password-success');
		this._$successModal.addEventListener('hidden.bs.modal', () => {
			$('#modal-password-success .text').text('');
		});
	}


	/**
	 * 'click' のコールバック
	 *
	 * @memberof SetTmpPassword
	 * @return {undefined}
	 */
	onClick() {
		console.log(`SetTmpPassword.onChange`);
		this._controller.setTmpPassword();
	}
}
